import { default as algoliaSearchInsights } from 'search-insights'

import { ALGOLIA_INDEX_PRODUCT } from '@src/config/env'
import { DEFAULT_LANGUAGE } from '@src/config/localisation/locale-config.constants'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'

import { getLbUserIdWithoutColons } from '../../utils/getlb-user-id'
import { getLocalePrefix } from '../checkoutService/checkoutUrl.helper'

import { isSearchResult } from './utils'

// @i18n-ignore
const ALGOLIA_APP_ID = 'K81D2WQH9L'
// @i18n-ignore
const ALGOLIA_SEARCH_KEY = '3f306f13f22cfa9128f18019ba17dc34'

interface TAlgoliaAddedToCartEvent {
  objectID: string
  queryID: string
}

interface TAlgoliaTrackClick {
  objectID?: string
  position?: number
  queryID?: string
}

// Initialize Algolia insights for event tracking
algoliaSearchInsights('init', {
  appId: ALGOLIA_APP_ID,
  apiKey: ALGOLIA_SEARCH_KEY,
})

// BE has created separate indexes for each locale, so we need to use the appropriate index for the current locale
// Index updation logic is the same on BE.
const getLocalisedTrackingAlgoliaIndex = () => {
  const locale = getLocalePrefix().toLowerCase()
  const isDefaultLocale = locale === DEFAULT_LANGUAGE
  const normalizedLocale = locale.replace('-', '_')
  return isDefaultLocale ? ALGOLIA_INDEX_PRODUCT : ALGOLIA_INDEX_PRODUCT + '_' + normalizedLocale
}

export function trackClickForSearchResultsProduct({ objectID, position, queryID }: TAlgoliaTrackClick) {
  void algoliaSearchInsights('clickedObjectIDsAfterSearch', {
    userToken: getLbUserIdWithoutColons(),
    eventName: TELEMETRY_EVENT_NAMES.PRODUCT_CLICK,
    index: getLocalisedTrackingAlgoliaIndex(),
    queryID: queryID ?? '',
    objectIDs: objectID ? [objectID] : [],
    positions: position ? [position] : [],
  })
}

export function trackClickObjectIds({ objectID }: TAlgoliaTrackClick) {
  void algoliaSearchInsights('clickedObjectIDs', {
    userToken: getLbUserIdWithoutColons(),
    eventName: TELEMETRY_EVENT_NAMES.PRODUCT_CLICK,
    index: getLocalisedTrackingAlgoliaIndex(),
    objectIDs: objectID ? [objectID] : [],
  })
}

export function trackPageViewForProduct({ objectID }: { objectID?: string }) {
  void algoliaSearchInsights('viewedObjectIDs', {
    userToken: getLbUserIdWithoutColons(),
    index: getLocalisedTrackingAlgoliaIndex(),
    eventName: TELEMETRY_EVENT_NAMES.PRODUCT_VIEW,
    objectIDs: objectID ? [objectID] : [],
  })
}

export function trackAddToCartForSearchResultsProduct({ objectID, queryID }: TAlgoliaAddedToCartEvent) {
  void algoliaSearchInsights('addedToCartObjectIDsAfterSearch', {
    userToken: getLbUserIdWithoutColons(),
    index: getLocalisedTrackingAlgoliaIndex(),
    eventName: TELEMETRY_EVENT_NAMES.ADD_TO_CART,
    queryID: queryID,
    objectIDs: [objectID],
  })
}

export function trackAddedToCartObjectIDs({ objectID }: { objectID: string }) {
  void algoliaSearchInsights('addedToCartObjectIDs', {
    userToken: getLbUserIdWithoutColons(),
    index: getLocalisedTrackingAlgoliaIndex(),
    eventName: TELEMETRY_EVENT_NAMES.ADD_TO_CART,
    objectIDs: [objectID],
  })
}

export const handleTrackAddedToCartAlgolia = ({ objectID, queryID }: TAlgoliaAddedToCartEvent) => {
  if (isSearchResult()) trackAddToCartForSearchResultsProduct({ objectID, queryID })
  else trackAddedToCartObjectIDs({ objectID })
}

export const handleAlgoliaClickEvent = ({ objectID, position, queryID }: TAlgoliaTrackClick) => {
  if (isSearchResult()) trackClickForSearchResultsProduct({ objectID, position, queryID })
  else trackClickObjectIds({ objectID })
}
